module.exports = __webpack_public_path__ + "img/Super-Recognition.0219687b.png";